import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * A ModalContainer is required for using useModal().
 */
import React, { createContext, useContext, useId } from "react";
import { globalBlur } from "../helpers/dom";
function dummy() { }
export const ModalContext = createContext({
    init: false,
    addModal: () => { return 'uninit'; },
    modifyModal: () => { return 'uninit'; },
    removeModal: dummy,
});
export function useModal(Component, props = {}) {
    const id = useId();
    const modalState = useContext(ModalContext);
    if (!(modalState === null || modalState === void 0 ? void 0 : modalState.init))
        throw new Error('useModal must be called within a <ModalContainer> or use a ModalContext');
    const showModalHandler = (propsOverride = {}) => {
        modalState.addModal(id, Component, { ...props, ...propsOverride });
    };
    const dismissModalHandler = () => {
        modalState.removeModal(id);
    };
    const modifyModalHandler = (propsOverride) => {
        modalState.modifyModal(id, { ...props, ...propsOverride });
    };
    return [showModalHandler, dismissModalHandler, modifyModalHandler, id];
}
/// A container in which you can use useModal() to show modals.
const ModalContainer = ({ children }) => {
    const [modals, setModals] = React.useState({});
    function addModal(id, Component, props) {
        setModals(modals => ({ ...modals, [id]: { Component, props } }));
        globalBlur();
        return id;
    }
    function modifyModal(id, props, merge = true) {
        setModals(modals => modals[id] ? ({ ...modals, [id]: { Component: modals[id].Component, props: merge ? { ...modals[id].props, ...props } : props } }) : modals);
        return id;
    }
    function removeModal(id) {
        setModals(modals => {
            const newModals = { ...modals };
            delete newModals[id];
            return newModals;
        });
        globalBlur();
    }
    return _jsxs(ModalContext.Provider, { value: { init: true, addModal, modifyModal, removeModal }, children: [children, _jsx("div", { className: 'flowFormModalSpace', children: Object.entries(modals).map(([id, { Component, props }]) => (_jsx("div", { className: 'flowFormModal', children: _jsx(Component, { ...props }) }, id))) })] });
};
export default ModalContainer;
